import styled from "styled-components";
import { colors } from "colors";

export const InsightsWrapper = styled.div<{ tabs: number }>`
  .tabs-header {
    display: flex;
    background: white;
    border-radius: 8px;
    gap: 0px;
    margin-bottom: 0px;
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 5px 5px 0 0;
    border-bottom: 1px solid #e5e7eb;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 3px;
      background: linear-gradient(356deg, ${colors.mainGreen} 0%, #4cabca 100%);
      transition: all 0.3s ease;
      width: calc(100% / ${props => props.tabs});
      transform: translateX(calc(100% * var(--active-tab-index, 0)));
    }
  }

  .tab-button {
    padding: 12px 24px;
    border: none;
    background: transparent;
    color: black;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;
    position: relative;
    flex: 1 1 0;
    min-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;

    &.active {
      background: #1f2937;
    }

    &:hover:not(.active) {
      background: rgba(31, 41, 55, 0.1);
    }

    @media (max-width: 1200px) {
      padding: 12px 16px;
      font-size: 13px;
    }

    @media (max-width: 900px) {
      padding: 12px 12px;
      font-size: 12px;
    }

    @media (max-width: 700px) {
      padding: 12px 8px;
      font-size: 11px;
    }
  }

  .tab-content {
    padding: 0px 0;
  }

  .active-tab-content {
    font-size: 14px;
    background: linear-gradient(356deg, ${colors.mainGreen} 0%, #4cabca 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;